import emailVerification from './email-verification';
import multiStepForm from './multi-step-form';
import DomainCheck from './domain-check';
import emailCheck from './email-check';
import validationDomainHelp from './validation-domain-help';

export default class SignupValidator {

    constructor($signupForm, type) {
        this.$signupForm = $signupForm;
        this.type = type; //personal/business
        this.backupEmailSelector;

        // Update an initial form, to have only needed fields
        this.$signupForm.validator('update');

        const that = this;

        this.customValidators = {
            isPasswordStrong: ($el, callback) => {
                let isStrong = true;

                if (!$el.data('is-password-strong')) {
                    isStrong = false;
                }

                return callback(isStrong);
            },
            emailVerificationSend: ($el, callback) => {
                this.backupEmailSelector = $el;
                var value = this.backupEmailSelector.val();
                console.log('signup validator: email: '+this.backupEmailSelector.val());
                if (!value) {
                    console.log('signup validator: empty email');

                    return;
                }

                const emailVerificationInstance = new emailVerification(value, this.type);
                emailVerificationInstance.sendConfirmationCode(function(sent) {
                    console.log('signup validator: sendConfirmationCode sent: '+sent);

                    if (sent) {
                        console.log('signup validator: all ok, removing validation errors');
                        $el.data('bs.validator.errors', []);

                        emailVerification.prototype.alreadySent[that.backupEmailSelector.val()] = true;
                    } else {
                        if (that.type === 'personal') {
                            const emailToRegister = document.getElementById('username').value + document.getElementById('username-placeholder').innerHTML;
                            //if for personal backup e-mail is the same as e-mail user tries to register,
                            // show custom message
                            if (value === emailToRegister) {
                                $el.data('bs.validator.errors', [$el.data('bs.validator.error.notthesame')]);
                            } else {
                                $el.data('bs.validator.errors', [$el.data('bs.validator.error.verification')]);
                            }
                        } else {
                            console.log(['not sent! add error: ',$el.data('bs.validator.error.verification')]);

                            $el.data('bs.validator.errors', [$el.data('bs.validator.error.verification')]);
                        }
                    }

                    return callback(sent);
                });
            },
            emailVerificationConfirm: ($el, callback) => {
                if (!this.backupEmailSelector) {
                    //console.log('first we need to send to backup email before confirming');
                    return callback(false);
                }
                const emailVerificationInstance = new emailVerification(this.backupEmailSelector.val(), this.type);
                emailVerificationInstance.verifyConfirmationCode($el.val(), function (verified) {
                    if (!verified) {
                        $el.data('bs.validator.errors', [$el.data('bs.validator.error')]);
                    }

                    return callback(verified);
                });
            },
            isDomainAvailable: ($el, callback) => {
                const domainCheckInstance = new DomainCheck($el.val());
                if (!domainCheckInstance.isValid()) {
                    return callback(false);
                }
                domainCheckInstance.isAvailable((isAvailable) => {
                    return callback(isAvailable);
                });
            },
            isEmailAvailable: ($el, callback) => {
                console.log('isEmailAvailable check start');
                const isEmailAvailableCheckType = $el.data('isemailavailabletype');
                let emailToCheck = $el.val();
                if (isEmailAvailableCheckType === 'personal') {
                    if (emailToCheck.length < 2) { //no need to make an ajax call if it is one char long e-mail
                        callback(false);
                    }
                    emailToCheck = emailToCheck+'@inbox.eu';
                }
                const emailCheckInstance = new emailCheck(emailToCheck, isEmailAvailableCheckType);
                console.log('isEmailAvailable emailCheckInstance.isValid: '+emailCheckInstance.isValid());

                if (!emailCheckInstance.isValid()) {
                    return callback(false);
                }
                emailCheckInstance.isAvailable((isAvailable) => {
                    console.log('isEmailAvailable emailCheckInstance.isAvailable: '+isAvailable);
                    return callback(isAvailable);
                });
            },
            sendValidationHelp: ($el, callback) => {
                const validationDomainHelpInstance = new validationDomainHelp($el.val(), $('#firstName').val(), $('#domain').val());

                validationDomainHelpInstance.sendValidationDomainHelp((isSend) => {
                    return callback(isSend);
                });
            }
        };

        //todo rewrite to native js
        const $continueButton = this.$signupForm.find('button[type="submit"]');

        this.$signupForm.on('submit', (e) => {
            $.Deferred.exceptionHook = function (err, stackTrace) {
                // To avoid error: cannot read property 'disable' of null
            }

            this.$signupForm.validator('destroy');
            $continueButton.attr('disabled', 'disabled');
        });

        $continueButton.on('keypress click', (e) => {
            if (e.target.id === 'submit') {
                // Submit form
                return;
            }

            //this is bad but works. we need to add click event for this specific element better
            const continueBtn = $('button[type="submit"][data-next_tab]:visible');
            console.log(['continueBtn', continueBtn]);

            if (continueBtn.is(':disabled') || continueBtn.hasClass('disabled')) {
                console.log('continue button still disabled, not switching to next');
                // Wait until fields will not be correct
                return;
            }

            if (continueBtn.length > 0) {
                // This will be step button and no need to submit form;
                e.preventDefault();
            } else {
                // Submit form
                return;
            }
            this.$signupForm.validator('update');
            if (!continueBtn.is(':visible')) {
                console.log('next button already visible, skipping switching to it');

                // Submit form
                return;
            }
            this.$signupForm.validator('validate');

            const isValidatedViaPlugin = !this.$signupForm.data('bs.validator').hasErrors() &&
                !this.$signupForm.data('bs.validator').isIncomplete();
            //call our custom inbox validation as validation plugin does not work via async ajax
            console.log('is form valid: '+isValidatedViaPlugin);

            const inboxValidators = continueBtn
                .closest('.form_tab')
                .find(':input:not([type="hidden"], [type="submit"], [type="reset"], button)[data-inboxvalidation]');

            var skipConfirmationStep = false;
            if (inboxValidators.length > 0) {
                let promises = [];
                inboxValidators.each(function() {
                    const $el = $(this);

                    //multiple validators per field
                    const inboxValidatorNames = $el.data('inboxvalidation').split(',');
                    inboxValidatorNames.forEach((inboxValidatorName) => {
                        const inboxValidator = that.customValidators[inboxValidatorName];
                        console.log('inboxValidator to check: '+inboxValidatorName);
                        //todo looks ugly. probably logic should be moved to emailVerificationSend
                        if (inboxValidatorName === 'emailVerificationSend' && !$el[0].value) {
                            console.log('inboxValidators: skipped confirmation step');

                            skipConfirmationStep = true;
                            return;
                        }

                        let validationCheck = new Promise((resolve, reject) => {
                            inboxValidator($el, function(valid) {
                                console.log(['inboxValidators: el: ', $el, 'is valid: ' + valid]);
                                if (valid) {
                                    // $el.removeData('bs.validator.errors');
                                    $el.data('bs.validator.errors', []);
                                    resolve();
                                } else {
                                    const customValidator = new $.fn.validator.Constructor($el, $.fn.validator.Constructor.DEFAULTS);
                                    //todo not sure why there was hardcoded error for verification
                                    // $el.data('bs.validator.errors', [$el.data('bs.validator.error.verification')]);
                                    customValidator.showErrors($el);
                                    reject(new Error('inboxValidators: not valid: '+inboxValidatorName));
                                }

                                return valid;
                            });
                        });

                        promises.push(validationCheck);
                    });
                });
                Promise.all(promises)
                    .then(() => {
                        console.log('Promise skipConfirmationStep: '+skipConfirmationStep);
                        console.log('Promise isValidatedViaPlugin: '+isValidatedViaPlugin);
                        if (isValidatedViaPlugin && !skipConfirmationStep) {
                            that.goToNextTab(continueBtn[0].dataset.next_tab);
                        } else {
                            that.goToNextTab('signup_personal_welcome');
                        }
                    })
                    .catch((error) => {
                        console.error(['inboxValidators: promise error', error]);
                        //todo maybe add validation errors here?
                    });
            } else {
                //switch to next tab
                console.log('no inbox validators defined');
                if (isValidatedViaPlugin) {
                    that.goToNextTab(continueBtn[0].dataset.next_tab);
                }
            }
        });
    }

    goToNextTab(nextTab) {
        multiStepForm.switchToTab(nextTab);
    }
}
